import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Results from "@/pages/Results";
import History from "@/pages/History";
import Settings from "@/pages/Settings";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Pricing from "@/pages/Pricing";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import AuthCallback from "@/pages/AuthCallback";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Intelligence from "@/pages/Intelligence";
import Admin from "@/pages/Admin";
import { AuthProvider } from "@/contexts/AuthContext";

function AppRouter() {
  const location = useLocation();
  // Process Google OAuth return synchronously (before any route/auth check).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/audit/:id" element={<Results />} />
      <Route path="/history" element={<History />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/intelligence" element={<Intelligence />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/pro" element={<Pricing />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(13,16,24,0.9)",
            backdropFilter: "blur(12px)",
            border: "1px solid rgba(34,211,238,0.35)",
            borderRadius: "10px",
            color: "#E7ECF3",
            fontFamily: "'JetBrains Mono', monospace",
            boxShadow: "0 0 24px rgba(34,211,238,0.2)",
          },
        }}
      />
    </div>
  );
}

export default App;
